import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface ContainerProps {
    children: ReactNode
    className?: string
}

export const CONTAINER_CLASSES = 'mx-auto w-full max-w-[1440px] px-5 md:px-8 lg:px-10'

export const Container: FC<ContainerProps> = ({ children, className }): ReactNode => {
    return (
        <div className={cn(CONTAINER_CLASSES, className)}>
            {children}
        </div>
    )
}
